export default __webpack_public_path__ + "static/media/0x576c990a8a3e7217122e9973b2230a3be9678e94.1b10e383.webp";